<i18n lang="yaml">
en:
  name: 'Name*'
  email: 'E-mail*'
  phone: 'Phone*'
  comment: 'Comment'
  agreement: 'I agree  with the processing of personal data according to the'
  policy: 'Policy'
  subscribe: 'Sign up for news'
  submit: 'Submit'
  consultation: 'You can always get a&nbsp;free consultation by&nbsp;calling&nbsp;us on&nbsp;{0}, sending a&nbsp;message to&nbsp;{2} or&nbsp;an&nbsp;e-mail to&nbsp;{1}.'
ru:
  name: 'Имя*'
  email: 'Эл. почта*'
  phone: 'Телефон*'
  comment: 'Комментарий'
  agreement: 'Я даю Согласие на обработку персональных данных на условиях, определенных'
  policy: 'Политикой конфиденциальности'
  subscribe: 'Подписаться на новости'
  submit: 'Отправить заявку'
  consultation: 'Вы&nbsp;всегда можете получить бесплатную консультацию по&nbsp;телефону, {0}, почте {1} или в&nbsp;{2}.'
</i18n>

<template>
  <s-section
    id="form"
    type="inverse"
    class="form-request"
    :style="`background-image: url(${formBackground})`"
  >
    <div class="row">
      <div class="col-xl-10 mx-auto">
        <div class="row">
          <div class="col-xl-6 col-lg-8 mx-auto">
            <h2
              class="form-request__title"
              v-html="form.title"
            ></h2>
            <div class="form-request__description">
              <p
                v-if="form.description"
                v-html="form.description"
              ></p>
              <p
                v-html="$t('consultation', [`
                  <a
                    class='mgo-number'
                    href='tel:88005550675'
                    data-gtmid='gtm-selectel-call-click'
                  >8&nbsp;800&nbsp;555&nbsp;06&nbsp;75</a>`, `
                  <a
                    href='mailto:${mail}'
                    data-gtmid='gtm-selectel-mailto-click'
                  >${mail}</a>`, `
                  <a
                    href='https://t.me/SelectelTgbot'
                    data-gtmid='gtm-selectel-telegram-click'
                  >Telegram</a>`])"
              ></p>
            </div>
          </div>
          <div class="col-xl-6 col-lg-8 mx-auto">
            <a-form-model
              v-if="!message"
              ref="form"
              :model="formRequest"
              :rules="rules"
              class="form-request__form"
              @submit.prevent="submitHandler"
            >
              <a-form-model-item
                ref="name"
                prop="name"
              >
                <a-input
                  v-model="formRequest.name"
                  class="input input"
                  :disabled="isDisabledForm"
                  :placeholder="$t('name')"
                ></a-input>
              </a-form-model-item>

              <a-form-model-item
                ref="email"
                prop="email"
              >
                <a-input
                  v-model="formRequest.email"
                  :disabled="isDisabledForm"
                  :placeholder="$t('email')"
                ></a-input>
              </a-form-model-item>

              <a-form-model-item
                ref="phone"
                prop="phone"
              >
                <a-input
                  v-model="formRequest.phone"
                  :disabled="isDisabledForm"
                  :placeholder="$t('phone')"
                ></a-input>
              </a-form-model-item>

              <a-form-model-item
                ref="comment"
                prop="comment"
              >
                <a-textarea
                  v-model="formRequest.comment"
                  :disabled="isDisabledForm"
                  :placeholder="$t('comment')"
                ></a-textarea>
              </a-form-model-item>

              <a-form-model-item
                ref="isAgree"
                prop="isAgree"
              >
                <a-checkbox
                  v-model="formRequest.isAgree"
                  :disabled="isDisabledForm"
                >
                  {{ $t('agreement') }}
                  <nuxt-link :to="localePath('/about/documents/personal-data/')">
                    {{ $t('policy') }}
                  </nuxt-link>
                </a-checkbox>
              </a-form-model-item>

              <a-form-model-item
                ref="isSubscribe"
                prop="isSubscribe"
              >
                <a-checkbox
                  v-model="formRequest.isSubscribe"
                  :disabled="isDisabledForm"
                >
                  {{ $t('subscribe') }}
                </a-checkbox>
              </a-form-model-item>

              <a-form-model-item>
                <recaptcha @success="isRecaptchaSuccess = true"></recaptcha>
              </a-form-model-item>

              <button
                class="btn btn--dark btn--lg btn--responsive"
                :disabled="isDisabledForm"
                @click.prevent="submitHandler"
              >
                {{ $t('submit') }}
              </button>
            </a-form-model>

            <p
              v-else
              v-html="message"
            ></p>
          </div>
        </div>
      </div>
    </div>
  </s-section>
</template>

<script>
import RestClient from '~/rest-client'

const restClient = new RestClient()

export default {
  name: 'FormRequest',
  props: {
    form: {
      type: Object,
      default: () => null
    },
    mail: {
      type: String,
      default: 'sales@selectel.ru'
    }
  },
  data() {
    return {
      rules: {
        name: [
          {
            required: true,
            message: 'Введите имя',
            transform: value => (
              value
                ? value.replace(/\s/g, '')
                : ''
            ),
            trigger: 'blur'
          }
        ],
        email: [
          {
            type: 'email',
            message: 'Введите корректный e-mail',
            trigger: 'blur'
          },
          {
            required: true,
            message: 'Введите e-mail',
            trigger: 'blur'
          }
        ],
        phone: [
          {
            pattern: /^(\s*)?(\+)?([- _():=+]?\d[- _():=+]?){10,14}(\s*)?$/,
            message: 'Введите корректный номер',
            trigger: 'blur'
          },
          {
            required: true,
            message: 'Введите номер',
            rigger: 'blur'
          }
        ],
        comment: [
          {
            required: false
          }
        ],
        isAgree: [
          {
            type: 'enum',
            enum: [true],
            required: true,
            message: 'Подтвердите согласие на обработку персональных данных',
            trigger: 'change'
          }
        ]
      },
      formRequest: {
        name: null,
        email: null,
        phone: null,
        comment: '',
        isAgree: null,
        isSubscribe: null
      },
      isDisabledForm: false,
      isRecaptchaSuccess: false,
      message: null
    }
  },
  computed: {
    formBackground() {
      return this.form.background_image
        ? this.form.background_image
        : ''
    }
  },
  beforeMount() {
    this.$recaptcha.language = this.$i18n.locale
  },
  methods: {
    async submitHandler() {
      await this.$refs.form.validate(async isValidForm => {
        if (!isValidForm || !this.isRecaptchaSuccess) return false

        const token = await this.$recaptcha.getResponse()

        this.isDisabledForm = true

        await restClient.recaptcha.post(token)
          .then(res => res.json())
          .then(res => !res.response.checked || res.response.recaptcha.success)
          .then(isSuccess => {
            if (isSuccess) {
              this.makeRequests()
            } else {
              this.$recaptcha.reset()

              this.isDisabledForm = false
            }
          })
          .catch(() => {
            this.makeRequests()
          })
      })
    },
    async makeRequests() {
      this.$gtmSendEvent({
        'event': 'ordersend',
        'eventAction': 'Form Sent',
        'eventLabel': document.location.href
      })

      await Promise
        .all([
          restClient.proxy.amocrm.post(this.formRequest),
          restClient.proxy.esputnik.post(this.formRequest)
        ])
        .then(() => {
          this.message = 'Ваша заявка принята. <br> Наши менеджеры свяжутся с вами в ближайшее время.'
        })
        .catch(() => {
          this.message = 'Ошибка соединения. <br> Попробуйте повторить запрос позже.'
        })
    }
  }
}
</script>

<style lang="scss">
.form-request {
  color: #FFF;
  background-color: $primary;
  background-size: cover;
  background-position: center;

  @media (max-width: $breakpoint-md) {
    padding-top: 48px;
    padding-bottom: 48px;
  }

  .ant-checkbox + span {
    @media (max-width: $breakpoint-sm) {
      font-size: 12px;
    }
  }
}

.form-request__title {
  max-width: 560px;
  margin: 24px 0 24px;
  color: #FFF;
}

.form-request__description {
  max-width: 560px;
  margin-bottom: 24px;
  color: #FFF;

  @media (max-width: $breakpoint-xl) {
    margin-bottom: 64px;
  }

  @media (max-width: $breakpoint-md) {
    font-size: 16px;
  }

  p {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    color: #FFF;
    text-decoration: underline;
    font-weight: 500;
  }
}

.form-request__form {
  padding: 40px;
  border-radius: 8px;

  background-color: #FFF;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08), 0 0 2px rgba(0, 0, 0, 0.08);

  @media (max-width: $breakpoint-md) {
    padding: 32px 16px;
  }
}
</style>